module.exports = __webpack_public_path__ + "static/media/icon-rule-success.8c8b5625.svg";